import { z } from 'zod';

export type StatsPublicDto = z.infer<typeof statsPublicDtoSchema>;

export const statsPublicDtoSchema = z.object({
  publicMobility: z.array(
    z.object({
      transportationMode: z.string(),
      replies: z.string(),
      totalPassengerCount: z.string(),
      totalTravelDistance: z.string(),
      totalScore: z.number(),
    }),
  ),
  publicAccommodation: z.array(
    z.object({
      accommodationType: z.string(),
      replies: z.string(),
      totalGuestCount: z.string(),
      totalNumberOfNights: z.string(),
      totalScore: z.number(),
    }),
  ),
  averageNumberOfNights: z.string().or(z.number()),
  numberOfNights: z.string().or(z.number()),
});
